import {useReservation} from 'context/reservation';

function useFaqEnabled() {
  const {housing} = useReservation();

  return Boolean(housing?.faq_enabled);
}

export {useFaqEnabled};
